<template>
  <div>
    <div class="card">
      <div class="card-content small-itinerary-body">
        <div class="content">
          <div v-if="nothingBooked">
            <span class="is-size-5">
              Your itinerary is empty
            </span>
            <p class="my-3">
              A summary of your trip will display here as you select your travel
              options.
            </p>
            <p class="my-3">
              <a @click="goToStart">Start your booking now</a>
            </p>
          </div>

          <!-- Navigation Buttons-->
          <div>

          <div v-if="orderedSegments['flight']">
            <ItineraryFlight
              :flight="sol.flight"
              :segments="orderedSegments['flight']"
              :traveler="profile"
              :guests="$store.state.bookTravel.guests"
              :multiLegs="multiLegs"
              @add="$nav.pushRouteTo({ path: 'flights' })"
              :show-header="true"
              class="mb-5"
            />
          </div>
          <div v-else-if="showAddFlight">
            <div>
              <b-button
                v-if="!modifyingTrip"
                size="is-default"
                @click="$nav.pushRouteTo({ path: 'flights' })"
                expanded
                v-html="addText('flight')"
              >
              </b-button>
            </div>
          </div>

          <div v-if="orderedSegments['hotel']">
            <ItineraryHotel
              :room="orderedSegments['hotel']"
              :key="sol.hotel.key"
              @add="$nav.pushRouteTo({ path: 'hotels' })"
              :show-header="true"
              class="mb-5 pt-6"
            />
          </div>
          <div v-else-if="showAddHotel">
            <div class="">
              <b-button
                size="is-default"
                @click="$nav.pushRouteTo({ path: 'hotels' })"
                expanded
                v-html="addText('hotel')"
                class="mb-1"
              >
              </b-button>
            </div>
          </div>

          <div v-if="orderedSegments['car']">
            <ItineraryCar
              :sol="orderedSegments['car']"
              :key="sol.car.id"
              @add="$nav.pushRouteTo({ path: 'cars' })"
              :show-header="true"
              class="mb-5 pt-6"
            />
          </div>
          <div v-else-if="showAddCar">
            <div class="">
              <b-button
                size="is-default"
                @click="$nav.pushRouteTo({ path: 'cars' })"
                expanded
                v-html="addText('car')"
              >
              </b-button>
            </div>
          </div>

        </div>  

        </div>
      </div>

      <div
        v-if="showFooter"
        class="card-footer is-flex is-justify-content-center"
      >
        <div v-if="!nothingBooked">
          <div v-if="bookTrip.currentlyBooking" class="p-3">
            <b-button
              expanded
              size="is-default"
              label="Proceed to Checkout"
              @click="$nav.pushRouteTo({ name: 'BookingCheckout' })"
              type="is-primary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin";
import ItineraryFlight from "./ItineraryFlight";
import ItineraryCar from "./ItineraryCar";
import ItineraryHotel from "./ItineraryHotel";
import meetingsMixin from '../../mixins/meetingsMixin';

export default {
  name: "SmallItineraryPiece",
  props: {
    sol: Object,
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [bookingMixin],
  components: {
    ItineraryCar,
    ItineraryFlight,
    ItineraryHotel,
  },
  data: function() {
    return {
      maximized: false,
    };
  },
  computed: {
    nothingBooked() {
      var solution = this.$store.state.bookTravel.result;
      return (
        Object.keys(solution.flight).length +
          Object.keys(solution.car).length +
          Object.keys(solution.hotel).length ===
        0
      );
    },
    profile() {
      return this.$store.state.travellersAndTrips.currentTravellerProfile;
    },
    showAddFlight(){
      if (this.pathMixin_isMeeting){
        return false;
      } 
      return true;
    },
    showAddCar(){
      if (this.pathMixin_isMeeting){
        return false;
      } 
      return true;
    },
    showAddHotel(){
      if (this.pathMixin_isMeeting){
        return false;
      } 
      return true;
    }
  },
  methods: {
    addText(type) {
      let text = `Add a ${type}`;
      if (this.bookingLocation) {
        let lowerCase = this.bookingLocation.city.toLowerCase();
        text = `Add a ${type} near&nbsp;<span class="gant-text">${lowerCase
          .charAt(0)
          .toUpperCase() + lowerCase.slice(1)}</span>`;
      }
      return text;
    },
    goToStart()   {

      if (this.pathMixin_isMeeting) {
        this.$nav.pushRouteTo({ path: "/meetings/flights" });
      } else {
        this.$nav.pushRouteTo({ path: "/search" });
      }

    },
  },
  mounted() {},
};
</script>

<style>
.small-itinerary,
.small-itinerary-body {
  max-height: 500px;
  overflow-y: auto;
}
</style>
